// extracted by mini-css-extract-plugin
module.exports = {"button-logout":"style_button-logout__PaMZb","buttonLogout":"style_buttonLogout__7aIge","icon":"style_icon__IFAYl"};